export class ShamirHash {
  private _encryptedKey: string
  private _encryptedHash: string
  private _employeeId: number

  constructor (employeeId: number, encryptedKey: string, encryptedHash: string) {
    if (encryptedKey === '' || encryptedHash === '') {
      throw new TypeError('Shamir Hashes not valid')
    }
    this._employeeId = employeeId
    this._encryptedHash = encryptedHash
    this._encryptedKey = encryptedKey
  }

  encryptedKey (): string {
    return this._encryptedKey
  }

  encryptedHash (): string {
    return this._encryptedHash
  }

  employeeId (): number {
    return this._employeeId
  }
}
